import React from 'react';
import { Dialog, DialogContent, Button, Grid, Typography } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import GuardianImage from '../../../../assets/images/New_Change_Img/20_min_pop_img.svg';
import './MinPromise.css';

const MinPromisePopup1 = ({ handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DialogContent>
      <Grid container direction="column" alignItems="center">
        {/* Image */}
        <Grid item>
          <img
            src={GuardianImage}
            alt="Add Guardian"
            style={{
              width: isMobile ? '120px' : '200px',
              height: 'auto',
              marginBottom: '10px',
            }}
          />
        </Grid>

        {/* Title */}
        <Grid item style={{ marginTop: '20px', width: '100%' }}>
          <Typography
            variant="h3"
            align="left" // Align text to the left
            fontSize={isMobile ? '24px' : '30px'}
            fontWeight="800"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Join the 20-Minute Promise!
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body1"
            align="left" // Align text to the left
            fontSize={isMobile ? '14px' : '18px'}
            fontWeight="700"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            At TaleTree, we believe that the bond between parent and child grows
            stronger through meaningful conversations.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            By making the 20-Minute Promise, you’re committing to spending just
            20 minutes each week with your child to discuss their creative
            journey, explore their imagination, and review insights from their
            activities on TaleTree.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Are you ready to commit to this and see life-changing results in
            your child and your bond together?
          </Typography>
        </Grid>
      </Grid>

      {/* Button */}
      <Grid container direction="column" alignItems="center">
        <Grid item width="100%" sx={{ maxWidth: '392px !important' }}>
          <button
            className="Yes_btn"
            style={{
              marginTop: isMobile ? '16px' : '20px',
              fontSize: isMobile ? '14px' : '16px',
              width: '100%',
            }}
            onClick={handleClose}
          >
            YES!!
          </button>
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default MinPromisePopup1;
